import * as UI from "@iyk/ui"

export type TextFieldProps = Omit<UI.Textbox.Props, "type"> & {
  type: "text" | "email"
  label: React.ReactNode
  optionalMessage?: React.ReactNode
  validationMessage?: string
  name: string
  affix?: {
    type: "prefix" | "suffix"
    text: string
  }
}

export const TextField = ({
  label,
  optionalMessage = <span className="text-gray-11">(Optional)</span>,
  name,
  validationMessage,
  required,
  affix,
  ...props
}: TextFieldProps) => {
  const isOptional = !required

  return (
    <UI.Field name={name} validationMessage={validationMessage} required={required}>
      <UI.Label>
        {label} {isOptional && optionalMessage}
      </UI.Label>
      {affix ? (
        <UI.TextboxAffix type={affix.type} text={affix.text}>
          <UI.Textbox {...props} />
        </UI.TextboxAffix>
      ) : (
        <UI.Textbox {...props} />
      )}

      <UI.Validity />
    </UI.Field>
  )
}
